
export function initStickyHeaderOnScroll(header) {

    const headerMainWrapper = header.querySelector(".headerMainWrapper");

    let lastScrollY = window.scrollY;
    let ticking = false;
    let isHiding = false;

    function updateStickyHeader() {
        const currentScrollY = window.scrollY;

        // Beim Hochscrollen (scrolling up)
        if (currentScrollY < lastScrollY && currentScrollY > 0) {
            header.classList.add('is-sticky');
            if(headerMainWrapper){
                headerMainWrapper.classList.add('is-sticky');
            }
            isHiding = false;
        } else {
            // Beim Runterscrollen oder ganz oben
            if (header.classList.contains('is-sticky') && !isHiding) {
                isHiding = true;
                header.classList.remove('is-sticky');
                if(headerMainWrapper){
                    headerMainWrapper.classList.remove('is-sticky');
                }
            }
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(updateStickyHeader);
            ticking = true;
        }
    });
}